export const BannerPositionClasses = {
  TOP: ['wf-w-full', 'wf-top-0'],
  BOTTOM: ['wf-w-full', 'wf-bottom-0'],
  FLOAT_BOTTOM: ['wf-w-11/12', 'wf-bottom-0', 'wf-mb-4', 'wf-mx-auto', 'wf-inset-x-0'],
}